import type { RadioButtonGroupProps, RadioButtonProps } from './RadioButton.types'
import * as Radix from '@radix-ui/react-radio-group'
import cn from 'classnames'
import styles from './RadioButton.module.css'

export function RadioButton({ ref, className, disabled, ...rest }: RadioButtonProps) {
  return (
    <Radix.Item
      className={cn(styles.radio, { [styles.disabled]: disabled }, className)}
      disabled={disabled}
      ref={ref}
      {...rest}
    >
      <Radix.Indicator className={styles.indicator} />
    </Radix.Item>
  )
}

export function RadioButtonGroup(props: RadioButtonGroupProps) {
  return <Radix.Root {...props} />
}

export default RadioButton
